import type { DemoStatusDto } from "@gazelab/shared";
import { Icon } from "./Icon.js";

/** Aviso de instalación en modo demo (panel, inicio de sesión y participantes). */
export function DemoBanner({ status, compact = false }: { status?: DemoStatusDto | null; compact?: boolean }) {
  const u = status?.usage;
  const l = status?.limits;
  return (
    <div role="note" data-testid="demo-banner" className="flex flex-wrap items-center gap-x-3 gap-y-1 rounded-xl bg-amber-100 px-3 py-2 text-sm text-amber-950 ring-1 ring-inset ring-amber-300">
      <span className="inline-flex items-center gap-1.5 font-bold">
        <Icon name="info" className="h-4 w-4" /> Versión de demostración
      </span>
      {u && l ? (
        <span className="font-util text-xs">
          Estudios {u.studies}/{l.studies} · Participaciones {u.participations}/{l.participations} · Imágenes o videos {u.mediaItems}/{l.mediaItems}
        </span>
      ) : (
        !compact && <span className="text-xs">Capacidad limitada: pocos estudios, participaciones y archivos.</span>
      )}
    </div>
  );
}
